module.exports = __webpack_public_path__ + "static/img/logo.3711510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 74
// module chunks = 1